<template>
    <div>
        <v-btn
            @click="action == 'create' ? save() : edit()"
            :disabled="disabled"
            class="buttons buttons--add"
        >
            {{ $t('global:save') }}
        </v-btn>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    i18nOptions: { namespaces: ['global'] },
    props: {
        action: {
            type: String,
        },
    },
    data() {
        return {
            disabled: false,
        }
    },
    computed:{
        ...mapGetters(['getRentAnnexDetails'])
    },
    methods: {
        ...mapActions(['createRentInfo', 'updateRentInfo']),
        async save() {
            this.disabled = true
            let success = await this.createRentInfo()
            if (success){ 
                this.$emit('closeModal')
            };
            this.disabled = false
        },
        async edit() {
            this.disabled = true
            let success = await this.updateRentInfo({ id:  this.$route.params.id })
            if (success) this.$emit('closeModal')
            
            this.disabled = false
        },
    },
}
</script>